/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions
import { setSelectedImage, setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import ImageToggle from 'material/embeds/imageapi/imagepane/pane/images/image_toggle';



/* ========== ~~~~~~~~~~ IMAGE TOGGLE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection // background, questionImage, option_0, option_1, option_2, option_3
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageToggle);
